export function isAnonymousLocation (location) {
  return (location || window.location).pathname.startsWith('/login')
}



// WEBPACK FOOTER //
// ./src/components/auth/isAnonymousLocation.js